import { TabBarItem } from './constants';
import TabBar from './TabBar';

interface TabBarFieldProps {
  value?: string;
  onChange?: (value: string) => void;
  items: TabBarItem[];
}

export default function TabBarField({
  value,
  onChange,
  items,
}: TabBarFieldProps) {
  return (
    <TabBar
      active={value}
      items={items}
      onActiveChange={(item) => onChange?.(item.value)}
    />
  );
}
